import { FALLBACK_ERROR_MESSAGE_KEY } from './global-error-message-keys.constant';

const TECHNICAL_MESSAGE_KEYS_BY_STATUS: Record<number, string> = {
  0: 'errors.networkOffline',
  500: 'errors.internalServerError',
  503: 'errors.serviceUnavailable',
  504: 'errors.requestTimeout',
};

export function getTechnicalErrorMessageKey(status: number): string {
  return TECHNICAL_MESSAGE_KEYS_BY_STATUS[status] ?? FALLBACK_ERROR_MESSAGE_KEY;
}
